function getRequestErrorMessage(error) {
  const responseMessage = error
    && error.response
    && error.response.data
    && error.response.data.message
  if (responseMessage) {
    return responseMessage
  }
  if (error && error.message) {
    return error.message
  }
  return '请求失败，请稍后重试。'
}

module.exports = {
  getRequestErrorMessage
}
